import { render, staticRenderFns } from "./SubcategoryItem.vue?vue&type=template&id=67344873&scoped=true"
import script from "./SubcategoryItem.vue?vue&type=script&lang=ts"
export * from "./SubcategoryItem.vue?vue&type=script&lang=ts"
import style0 from "./SubcategoryItem.vue?vue&type=style&index=0&id=67344873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67344873",
  null
  
)

export default component.exports